export const CopilotRole = Object.freeze({
	universalCode: 'copilot_assistant',
});
